export const FETCH_FEATURES = {
    REQUEST: 'FETCH_FEATURES_REQUEST',
    SUCCESS: 'FETCH_FEATURES_SUCCESS',
    FAILED: 'FETCH_FEATURES_FAILED',
};
